export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

export const setToken = async (token: string): Promise<void> => {
  window.localStorage.setItem('token', token);
};
